<template>
  <div class="topbar">
    <EmpresaSelector />
    <div
      v-if="souRevenda"
      style="position: relative; margin-top: 15px"
    >
      <input
        type="text"
        id="search-client"
        class="search-input"
        v-model="searchQuery"
        placeholder="Trocar de conta"
        autocomplete="off"
      />
      <div v-if="searchQuery && filteredClients.length > 0" class="client-list">
        <ul>
          <li
            v-for="client in filteredClients"
            :key="client.id"
            @click="selectClient(client)"
            class="client-item"
          >
            <strong style="margin-right: 10px">{{ client.cliente }} - {{ formatCpfCnpj(client.cnpj_cpf) }}</strong>
            <AccountCircle
              :size="20"
              style="margin-left: 50px; margin-right: 2px"
            />
            <span style="margin-left: 2px">&nbsp;</span>
          </li>
        </ul>
      </div>
    </div>
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1 pulse pulse-primary position-relative"
        >
          <span class="svg-icon svg-icon-xl">
            <inline-svg src="media/svg/icons/Code/Compiling.svg" />
          </span>
          <span class="pulse-ring" v-if="notificationStore.total > 0" />
          <span
            class="font-size-sm position-absolute notifications"
            v-if="notificationStore.total > 0"
            >{{ notificationStore.total }}</span
          >
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <KTDropdownNotification></KTDropdownNotification>
        </form>
      </b-dropdown-text>
    </b-dropdown>

    <KTQuickUser></KTQuickUser>
  </div>
</template>

<style lang="scss">
.notifications {
  right: 5px;
  bottom: 0;
}
.topbar {
  .dropdown-toggle {
    padding: 0;

    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;

    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import EmpresaSelector from "@/view/layout/header/EmpresaSelector.vue";
import { notificationStore } from "../../../notificationStore";
import swal from "sweetalert";
import { SistemaMixin } from "@/modules/Application";
import AccountCircle from "vue-material-design-icons/AccountArrowRightOutline.vue";
import JwtService from "@/core/services/jwt.service";
import { mapGetters, mapState } from "vuex";

export default {
  name: "KTTopbar",
  data() {
    return {
      notificationStore,
      souRevenda: false,
      searchQuery: "",
      clients: [],
      selectedClient: null,
    };
  },
  mixins: [SistemaMixin],
  components: {
    KTDropdownNotification,
    KTQuickUser,
    AccountCircle,
    EmpresaSelector,
  },
  methods: {
    normalizeSearchText(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },
    onlyDigits(value) {
      return String(value || "").replace(/\D/g, "");
    },
    resolveRevendaFromUser(user) {
      return (
        user?.isRevenda === true ||
        user?.is_revenda === true ||
        user?.empresa?.revenda === true ||
        user?.usuario_empresa?.empresa?.revenda === true ||
        Boolean(user?.empresa?.dados_revenda)
      );
    },
    getRevendaId(user) {
      const parceiro = user?.usuario_empresa?.empresa?.parceiro || {};
      const idRevendaDireto =
        parceiro?.id_revenda ??
        user?.idRevenda ??
        user?.id_revenda ??
        user?.empresa?.idRevenda ??
        user?.empresa?.id_revenda ??
        null;

      if (Number(idRevendaDireto) === 1) {
        return (
          parceiro?.id_empresa ??
          user?.empresa?.id_empresa ??
          user?.usuario_empresa?.id_empresa ??
          null
        );
      }

      return (
        idRevendaDireto ??
        parceiro?.id_empresa ??
        user?.empresa?.id_empresa ??
        user?.usuario_empresa?.id_empresa ??
        null
      );
    },
    async atualizarContextoRevenda(user) {
      const contextoParceiro =
        JwtService.getParceiro() === "true" ||
        JwtService.getParceiro() === true;

      this.souRevenda = this.isRevenda === true || contextoParceiro;

      if (!this.souRevenda) {
        this.clients = [];
        return;
      }

      const id_revenda = this.getRevendaId(user);
      if (!id_revenda) {
        this.clients = [];
        return;
      }

      try {
        const data = await this.$http.post("/empresa/meus-clientes-lista", {
          id_revenda,
        });
        this.clients = data?.data || [];
      } catch (e) {
        this.clients = [];
      }
    },
    selectClient(client) {
      this.selectedClient = client.id_empresa;
      this.searchQuery = client.cliente;

      swal({
        icon: "warning",
        title: "Deseja acessar a conta do cliente " + client.cliente + "?",
        showCancelButton: true,
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Sim",
            visible: true,
            closeModal: false,
          },
        },
        confirmButtonColor: "#f64e60",

        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();

        this.$toast.success(
          "Aguarde, carregando os dados referente ao clente..."
        );

        const response = await this.$http.post("/empresa/acessar-conta", {
          id_empresa: client.id_empresa,
          id_revenda: client.id_revenda,
        });

        if (response) {
          JwtService.saveTokenCliente(response.data.access_token);
          JwtService.saveEmpresaId(client.id_empresa);
          JwtService.saveParceiro(true);
        }

        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    },
  },
  watch: {
    async currentUser(user) {
      await this.atualizarContextoRevenda(user);
    },
  },
  computed: {
    ...mapGetters(["isRevenda"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    filteredClients() {
      const query = this.normalizeSearchText(this.searchQuery);
      const queryDigits = this.onlyDigits(this.searchQuery);

      if (!query && !queryDigits) return this.clients;

      return this.clients.filter((client) => {
        const nome = this.normalizeSearchText(client?.cliente);
        const documento = String(client?.cnpj_cpf || "");
        const documentoDigits = this.onlyDigits(documento);

        const matchNome = query ? nome.includes(query) : false;
        const matchDocumentoTexto = query ? documento.includes(query) : false;
        const matchDocumentoDigitos = queryDigits
          ? documentoDigits.includes(queryDigits)
          : false;

        return matchNome || matchDocumentoTexto || matchDocumentoDigitos;
      });
    },
  },
  async mounted() {
    await this.atualizarContextoRevenda(this.currentUser);
  },
};
</script>

<style scoped>
.search-container {
  margin-left: 150px;
  margin-top: 20px;
}

input,
select {
  display: block;
  margin-bottom: 10px;
}
.client-list {
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  background-color: white;
  position: absolute; /* Permite o ajuste da posição */
  z-index: 1000; /* Para garantir que a lista fique acima de outros elementos */
  right: 0; /* Fixar à direita */
  left: auto; /* Evitar que a lista se mova para a esquerda */
}

.client-item {
  padding: 8px;
  cursor: pointer;
  display: flex; /* Usar flexbox para alinhar o ícone e o texto */
  align-items: center; /* Alinha verticalmente */
  width: 300px;
}

.client-icon {
  width: 20px; /* Defina o tamanho do ícone */
  height: 20px; /* Defina o tamanho do ícone */
  margin-right: 8px; /* Espaço entre o ícone e o texto */
}

.client-item:hover {
  background-color: var(--primary-color); /* Cor de fundo ao passar o mouse */
}

.search-input {
  color: white; /* Cor do texto digitado */
  background-color: transparent; /* Fundo transparente, se necessário */
  border: none; /* Remove as bordas */
  border-bottom: 2px solid white; /* Linha inferior branca */
  outline: none; /* Remove o contorno padrão ao focar */

  /* Transição suave para o foco */
  transition: border-bottom-color 0.3s ease-in-out;
}

/* Estilizando o placeholder para ficar branco */
.search-input::placeholder {
  color: white;
  opacity: 1; /* Garante que o placeholder fique totalmente visível */
}
</style>
